<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <loading-component>
        <template #content>
            <div class="flex flex-col gap-4 xl:mx-60">
                <div class="flex flex-row items-center gap-4">
                    <back-component></back-component>
                    <span class="text-2xl font-bold text-secondary">Neue Anwendung registrieren</span>
                </div>

                <upsert-client-component v-model="client" mode="register" @save="create"></upsert-client-component>
            </div>
        </template>
    </loading-component>
</template>

<script>
import LoadingComponent from '@/components/LoadingComponent';
import UpsertClientComponent from '@/components/clients/UpsertClientComponent';
import Notifications from '@auth/vue-share/utility/notifications';
import { mapStores } from 'pinia';
import { useClientsStore } from '@/stores/clients';
import BackComponent from '@/components/BackComponent';
import FieldUtility from '@/utility/field.utility';
import logger from '@auth/vue-share/utility/logger';

export default {
    name: 'CreateClientView',
    components: { BackComponent, UpsertClientComponent, LoadingComponent },
    data() {
        return {
            client: {
                name: undefined,
                description: undefined,
                client_type: 'public',
                url: undefined,
                redirect_uri: undefined,
                scopes: [
                    'openid' // openid defines it as default scope, I know it is safer to set it in the backend, but I am lazy
                ],
                claims: {
                    userinfo: {},
                    id_token: {}
                }
            }
        };
    },
    computed: {
        ...mapStores(useClientsStore)
    },
    methods: {
        create(client) {
            if (FieldUtility.isNull(['client_type', 'name', 'url', 'redirect_uri', 'scopes'], client)) return;

            this.clientsStore
                .createClient(client)
                .then((response) => {
                    Notifications.success('Anwedung erfolgreich registriert');
                    this.$router.push({ path: `/clients/${response.data.data.client_id}` });
                })
                .catch((error) => {
                    Notifications.error('Die Anwedung konnte nicht registriert werden');
                    logger.error('[CLIENT]', error);
                });
        }
    }
};
</script>

<style scoped></style>
